import { FC, KeyboardEvent, useState } from 'react';
import { useHistory } from 'react-router';
import { Capacitor } from '@capacitor/core';
import { Typography } from '@mui/material';
import classNames from 'classnames';
import { MapMarker, StaticGoogleMap } from 'components/shared';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { ROUTER_URL } from 'utils/enums';
import { FirebaseAnalytics } from 'utils/services';
import apartmentMapStyles from '../ApartmentCard/ApartmentMap/index.module.scss';
import apartmentMapContentStyles from '../ApartmentCard/ApartmentMapContent/index.module.scss';
import apartmentCardStyles from '../ApartmentCard/index.module.scss';
import styles from './index.module.scss';

export const HostCardOrderCard: FC = () => {
	const history = useHistory();
	const [cardElement, setCardElement] = useState<HTMLDivElement | null>(null);

	const handleClickCreateCard = (): void => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.PROFILE.HOME,
			FIREBASE_EVENT_ANALYTICS_BUTTON.CREATE_CARD_RADABANK
		);

		if (Capacitor.isNativePlatform()) {
			history.push(ROUTER_URL.RADABANK_CARD);
			return;
		}

		history.push(ROUTER_URL.PROFILE, { initialSlide: 1 });
	};

	const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>): void => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			handleClickCreateCard();
		}
	};

	return (
		<div
			ref={setCardElement}
			className={apartmentCardStyles.address_card}
			onClick={handleClickCreateCard}
			onKeyDown={handleKeyDown}
			role="button"
			tabIndex={0}
		>
			<div className={apartmentMapStyles.wrapper}>
				{!!cardElement && (
					<StaticGoogleMap
						width={cardElement.offsetWidth}
						height={cardElement.offsetHeight}
						lat={0}
						lng={0}
					/>
				)}
				<MapMarker className={apartmentMapStyles.marker} index={0} />
				<div className={classNames(apartmentMapContentStyles.wrapper, apartmentMapContentStyles.multiple, styles.content)}>
					<Typography className={styles.eyebrow} variant="overline">
						З HOSTCARD
					</Typography>
					<div>
						<Typography className={styles.title} variant="h6">
							Оплата комуналки без комісії
						</Typography>
						{/* <Typography className={styles.action} variant="body2">
							Детальніше
						</Typography> */}
					</div>
				</div>
			</div>
		</div>
	);
};
